<template>
  <div class="dialog-merchant-idcard-preview-wrapper">
    <el-dialog width="80%" :visible="visible" @open="onDialogOpen" @close="onDialogClose" style="text-align: center">
      <div class="dialog-upload-img">
        <div class="upload-img-form">
          <div class="upload-img-block">
            <h3>手持身份证照</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: previewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onHoldIdcardUploadSuccess" >
              <img
                @click="rotateImg(4)"
                v-if="holdIdcard.url"
                :src="holdIdcard.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(holdIdcard.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>身份证正面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: previewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onFrontIdcardUploadSuccess" >
              <img
                @click="rotateImg(5)"
                v-if="frontIdcard.url"
                :src="frontIdcard.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(frontIdcard.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>身份证反面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: previewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onBackIdcardUploadSuccess" >
              <img
                @click="rotateImg(6)"
                v-if="backIdcard.url"
                :src="backIdcard.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(backIdcard.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>银行卡正面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: previewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onFrontBankUploadSuccess" >
              <img
                @click="rotateImg(7)"
                v-if="frontBank.url"
                :src="frontBank.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(frontBank.url)">预览</el-button>
          </div>

          <div class="upload-img-block">
            <h3>银行卡反面</h3>
            <el-upload
              class="img-uploader"
              action="/api/v1/bank/merchant_info/img"
              :data="{ userid: previewingMerchant.userid }"
              :headers="getJWT()"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="onBackBankUploadSuccess" >
              <img
                @click="rotateImg(8)"
                v-if="backBank.url"
                :src="backBank.url">
              <i v-else class="el-icon-plus uploader-icon"></i>
            </el-upload>
            <el-button
              size="medium"
              style="margin-top: 1rem"
              @click="onImgPreview(backBank.url)">预览</el-button>
          </div>
        </div>
      </div>

      <el-form
        label-position="right"
        label-width="120px"
        ref="merchantForm"
        style="margin-top: 2rem; padding: 0 6rem;"
        v-model="merchantForm" >

        <el-form-item label="法人名称" prop="corpName">
          <el-input
            v-model="merchantForm.corpName"
            placeholder="请输入法人名称"
            @keyup.enter.native="onSaveClick"></el-input>
        </el-form-item>

        <el-form-item label="商户名称" prop="name">
          <el-input
            v-model="merchantForm.name"
            placeholder="请输入商户名称"
            @keyup.enter.native="onSaveClick"></el-input>
        </el-form-item>

        <el-form-item label="商户地址" prop="address">
          <el-input
            v-model="merchantForm.address"
            placeholder="请输入商户地址"
            @keyup.enter.native="onSaveClick"></el-input>
        </el-form-item>

        <el-form-item label="开户人" prop="acctName">
          <el-input
            v-model="merchantForm.acctName"
            placeholder="请输入商户地址"
            @keyup.enter.native="onSaveClick"></el-input>
        </el-form-item>

        <el-form-item label="开户账号" prop="acctNo">
          <el-input
            v-model="merchantForm.acctNo"
            placeholder="请输入商户地址"
            @keyup.enter.native="onSaveClick"></el-input>
        </el-form-item>

        <el-form-item label="身份证号" prop="certNo">
          <el-input
            v-model="merchantForm.certNo"
            placeholder="请输入身份证证件号"
            @keyup.enter.native="onSaveClick"></el-input>
        </el-form-item>

        <el-form-item label="身份证有效期" prop="certDate">
          <el-date-picker
            style="width: 49%"
            v-model="merchantForm.certStartDate"
            type="date"
            placeholder="有效起始日期">
          </el-date-picker>
          <el-date-picker
            style="width: 49%"
            v-model="merchantForm.certExpireDate"
            type="date"
            placeholder="有效结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>

      <div class="submit">
        <el-button
          type="danger"
          size="medium"
          @click="onSaveClick">更新</el-button>
        <el-button
          size="medium"
          @click="onResetClick">重置</el-button>
      </div>
    </el-dialog>

    <!--Image preview dialog-->
    <el-dialog :visible.sync="imgPreivewDialogViesible">
      <div style="display: flex; justify-content: center; align-items: center;">
        <img
          width="100%"
          :src="imgPreviewUrl"
          :style="{ transform: `rotate(${previewDegree}deg)` }"
          @click="rotateImg"
          alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import moment from 'moment'

export default {
  name: 'DialogMerchantIdcardPreview',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    previewingMerchant: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      imgPreivewDialogViesible: false,
      imgPreviewUrl: '',

      holdIdcard: {
        url: '',
        filename: ''
      },
      frontIdcard: {
        url: '',
        filename: ''
      },
      backIdcard: {
        url: '',
        filename: ''
      },
      frontBank: {
        url: '',
        filename: ''
      },
      backBank: {
        url: '',
        filename: ''
      },

      previewDegree: 0,

      merchantForm: {
        corpName: '',
        name: '',
        address: '',
        acctName: '',
        acctNo: '',
        certNo: '',
        certStartDate: '',
        certExpireDate: ''
      }
    }
  },
  methods: {
    ...mapActions('bank', [
      'updateMerchantInfoWithImg',
      'getIdcardImg'
    ]),
    onDialogOpen () {
      this.getIdcardImg({
        merchantId: this.previewingMerchant.merchant_id
      }).then(res => {
        this.holdIdcard.url = res.data.hold_id_card
        this.frontIdcard.url = res.data.id_card_z
        this.backIdcard.url = res.data.id_card_f
        this.frontBank.url = res.data.bank_z
        this.backBank.url = res.data.bank_f
      }).catch(err => {
        console.log(err)
      })

      // Set form default value
      this.holdIdcard.filename = this.previewingMerchant.hold_id_card
      this.frontIdcard.filename = this.previewingMerchant.id_card_z
      this.backIdcard.filename = this.previewingMerchant.id_card_f
      this.frontBank.filename = this.previewingMerchant.bank_z
      this.backBank.filename = this.previewingMerchant.bank_f

      this.merchantForm.certNo = this.previewingMerchant.acct_cert_no
      this.merchantForm.certStartDate = this.previewingMerchant.cert_start_date
      this.merchantForm.certExpireDate = this.previewingMerchant.cert_expire_date
      this.merchantForm.corpName = this.previewingMerchant.corp_name
      this.merchantForm.name = this.previewingMerchant.name
      this.merchantForm.address = this.previewingMerchant.address
      this.merchantForm.acctName = this.previewingMerchant.acct_name
      this.merchantForm.acctNo = this.previewingMerchant.acct_no
    },
    onDialogClose () {
      this.$emit('update:visible', false)
    },
    rotateImg (index) {
      this.previewDegree = this.previewDegree === 270 ? 0 : this.previewDegree + 90
    },

    beforeUpload (file) {
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImg) {
        this.$message.error('只能上传图片格式！')
      }
      if (!isLt2M) {
        this.$message.error('上传的图像不能大于 2MB ！')
      }
      return isImg && isLt2M
    },

    onHoldIdcardUploadSuccess (res, file, fileList) {
      this.holdIdcard.url = res.data.url
      this.holdIdcard.filename = res.data.filename
    },
    onFrontIdcardUploadSuccess (res, file, fileList) {
      this.frontIdcard.url = res.data.url
      this.frontIdcard.filename = res.data.filename
    },
    onBackIdcardUploadSuccess (res, file, fileList) {
      this.backIdcard.url = res.data.url
      this.backIdcard.filename = res.data.filename
    },
    onFrontBankUploadSuccess (res, file, fileList) {
      this.frontBank.url = res.data.url
      this.frontBank.filename = res.data.filename
    },
    onBackBankUploadSuccess (res, file, fileList) {
      this.backBank.url = res.data.url
      this.backBank.filename = res.data.filename
    },
    onImgPreview (url) {
      if (url === '') {
        this.$message({
          type: 'error',
          message: '请先上传图片'
        })
        return
      }
      this.imgPreviewUrl = url
      this.imgPreivewDialogViesible = true
    },

    async onSaveClick () {
      if (this.holdIdcard.filename === '' || this.frontIdcard.filename === '' ||
        this.backIdcard.filename === '' || this.frontBank.filename === '' ||
        this.backBank.filename === '') {
        this.$message({
          type: 'error',
          message: '请确保所有图片已经上传'
        })
        return
      }

      let startDate = new Date(this.merchantForm.certStartDate).getTime()
      let expireDate = new Date(this.merchantForm.certExpireDate).getTime()

      if (startDate > expireDate) {
        this.$message({
          type: 'warning',
          message: '开始时间不能大于结束时间'
        })
        return
      }

      try {
        const res = await this.updateMerchantInfoWithImg({
          merchantId: this.previewingMerchant.merchant_id,

          // Img
          holdIdcard: this.holdIdcard.filename,
          idcardZ: this.frontIdcard.filename,
          idcardF: this.backIdcard.filename,
          bankZ: this.frontBank.filename,
          bankF: this.backBank.filename,

          // Field
          corpName: this.merchantForm.corpName,
          name: this.merchantForm.name,
          address: this.merchantForm.address,
          acctName: this.merchantForm.acctName,
          acctNo: this.merchantForm.acctNo,
          certNo: this.merchantForm.certNo,
          certStartAt: moment(this.merchantForm.certStartDate).format('YYYY-MM-DD'),
          certExpireAt: moment(this.merchantForm.certExpireDate).format('YYYY-MM-DD')
        })

        if (res.rcode === 0) {
          this.$message({
            type: 'success',
            message: '更新商户身份证信息成功'
          })

          this.$emit('data-change')
          this.$emit('update:visible', false)
        } else {
          this.$message({
            type: 'error',
            message: '更新商户身份证信息失败'
          })
        }
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '更新商户身份证信息失败'
        })
      }
    },
    onResetClick () {
      // Set form default value
      this.merchantForm.certNo = this.previewingMerchant.acct_cert_no
      this.merchantForm.certStartDate = this.previewingMerchant.cert_start_date
      this.merchantForm.certExpireDate = this.previewingMerchant.cert_expire_date
      this.merchantForm.corpName = this.previewingMerchant.corp_name
      this.merchantForm.name = this.previewingMerchant.name
      this.merchantForm.address = this.previewingMerchant.address
      this.merchantForm.acctName = this.previewingMerchant.acct_name
      this.merchantForm.acctNo = this.previewingMerchant.acct_no
    },
    getJWT () {
      const userInfo = JSON.parse(localStorage.getItem('user_info'))
      if (userInfo === null) {
        return {}
      }

      return {
        'x-access-token': userInfo.token,
        'secret': userInfo.secret
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-merchant-idcard-preview-wrapper {

  .dialog-upload-img {

    .upload-img-form {
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      align-items: center;
      text-align: center;

      .upload-img-block {
        margin: 0 1.5rem;

        .img-uploader {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;

          &:hover {
            border-color: #409EFF;
          }
          .uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 178px;
            height: 178px;
            line-height: 178px;
            text-align: center;
          }
          img {
            width: 178px;
            height: 178px;
            display: block;
          }
        }
      }
    }

    .submit-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 18%;
      margin: 2rem auto 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bank/DialogMerchantIdcardPreview.vue